var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quesiton-title"},[(!_vm.is_random_question)?_c('drill-title'):_vm._e(),_c('drill-pen',{staticClass:"quesiton-title__pen"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }